var _use, _use2, _use3, _use4, _use5, _use6, _use7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadGoogleplay = function SvgDownloadGoogleplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 40,
    viewBox: "0 0 135 40",
    preserveAspectRatio: "none"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "download_googleplay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M.734-6.438H2.97c.37 0 .722.086 1.047.25.32.168.578.403.765.704.184.293.282.632.282 1.015A1.899 1.899 0 0 1 4.016-2.75c-.325.168-.676.25-1.047.25H1.75V0H.734Zm2.25 2.985c.227 0 .422-.047.579-.14.164-.102.289-.235.374-.391.083-.153.126-.317.126-.485a1.04 1.04 0 0 0-.125-.484.988.988 0 0 0-.376-.375 1.046 1.046 0 0 0-.578-.156H1.75v2.03Zm0 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "download_googleplay_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M3.75.14a3.352 3.352 0 0 1-1.703-.437A3.246 3.246 0 0 1 .844-1.516a3.403 3.403 0 0 1-.438-1.703c0-.62.145-1.191.438-1.703A3.303 3.303 0 0 1 3.75-6.594c.621 0 1.188.153 1.688.453.507.305.91.711 1.203 1.22.3.51.453 1.081.453 1.702 0 .617-.149 1.184-.438 1.703a3.303 3.303 0 0 1-1.203 1.22A3.372 3.372 0 0 1 3.75.14Zm0-.953a2.25 2.25 0 0 0 1.172-.312 2.23 2.23 0 0 0 .828-.844c.207-.363.313-.781.313-1.25 0-.465-.106-.883-.313-1.25a2.125 2.125 0 0 0-.828-.843 2.288 2.288 0 0 0-1.172-.313c-.43 0-.82.105-1.172.313-.355.199-.637.48-.844.843-.199.367-.296.785-.296 1.25 0 .469.097.887.296 1.25a2.3 2.3 0 0 0 .844.844c.352.21.742.313 1.172.313Zm0 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "download_googleplay_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M.734-6.438h2.422c.34 0 .66.075.953.22.29.148.52.355.688.624.176.262.266.555.266.875 0 .313-.083.59-.235.828-.156.23-.367.41-.625.532v.046c.32.118.582.31.781.579.207.261.313.57.313.921 0 .356-.098.676-.281.954-.18.273-.426.488-.735.64A2.338 2.338 0 0 1 3.266 0H.734ZM3.11-3.75c.29 0 .524-.086.704-.266a.852.852 0 0 0 0-1.234.868.868 0 0 0-.657-.266H1.75v1.766Zm.157 2.813c.3 0 .546-.094.734-.282a.964.964 0 0 0 .281-.672.907.907 0 0 0-.297-.671c-.187-.184-.441-.282-.75-.282H1.75v1.906Zm0 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "download_googleplay_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M.734-6.438H1.75V0H.734Zm0 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "download_googleplay_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M.734-6.438h3.922v.954H1.75v1.78h2.61v.954H1.75v1.781h2.906V0H.734Zm0 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "download_googleplay_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M.734-6.438H3c.383 0 .734.086 1.047.25.32.168.57.403.75.704.183.293.281.632.281 1.015 0 .43-.144.817-.422 1.157a1.967 1.967 0 0 1-1.031.671l-.016.047L5.375-.047V0H4.203L2.5-2.516h-.75V0H.734Zm2.25 2.985c.29 0 .54-.094.75-.281a.973.973 0 0 0 .329-.75 1.04 1.04 0 0 0-.125-.485 1.033 1.033 0 0 0-.36-.375 1.02 1.02 0 0 0-.562-.156H1.75v2.047Zm0 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "download_googleplay_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "m.344-1.031 3.36-4.453H.5v-.954h4.375v1.032L1.531-.97h3.375V0H.344Zm0 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "download_googleplay_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0Zm0 0"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M130 40H5c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h125c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#a6a6a6",
      fillOpacity: 1
    },
    d: "M130 0H5C2.25 0 0 2.25 0 5v30c0 2.75 2.25 5 5 5h125c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5m0 .8c2.316 0 4.2 1.884 4.2 4.2v30c0 2.316-1.884 4.2-4.2 4.2H5A4.203 4.203 0 0 1 .8 35V5C.8 2.684 2.685.8 5 .8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M106.938 30h1.863V17.5h-1.864Zm16.804-7.996-2.137 5.418h-.066l-2.219-5.418h-2.011l3.332 7.574-1.899 4.215h1.945l5.13-11.79Zm-10.582 6.578c-.61 0-1.465-.309-1.465-1.062 0-.965 1.063-1.336 1.98-1.336.821 0 1.208.175 1.704.418a2.26 2.26 0 0 1-2.219 1.98m.227-6.852c-1.352 0-2.75.594-3.332 1.91l1.66.696c.351-.695 1.012-.918 1.703-.918.965 0 1.945.578 1.96 1.605v.13c-.335-.192-1.062-.481-1.944-.481-1.786 0-3.602.98-3.602 2.812 0 1.676 1.465 2.75 3.102 2.75 1.257 0 1.949-.562 2.382-1.218h.063v.964h1.8v-4.793c0-2.218-1.656-3.457-3.792-3.457m-11.532 1.793H99.2v-4.285h2.656c1.395 0 2.184 1.157 2.184 2.145 0 .969-.789 2.14-2.184 2.14m-.05-6.023h-4.47V30H99.2v-4.734h2.606c2.07 0 4.101-1.5 4.101-3.883 0-2.387-2.031-3.883-4.101-3.883m-24.38 11.082c-1.288 0-2.366-1.078-2.366-2.562 0-1.497 1.078-2.594 2.367-2.594 1.273 0 2.27 1.097 2.27 2.594 0 1.484-.997 2.562-2.27 2.562m2.14-5.879h-.062c-.418-.5-1.227-.953-2.238-.953-2.13 0-4.079 1.871-4.079 4.27 0 2.386 1.95 4.238 4.079 4.238 1.011 0 1.82-.45 2.238-.969h.062v.613c0 1.63-.867 2.496-2.27 2.496-1.144 0-1.855-.82-2.144-1.511l-1.625.675c.465 1.13 1.707 2.512 3.77 2.512 2.191 0 4.043-1.285 4.043-4.43v-7.636h-1.774ZM82.63 30h1.867V17.496H82.63Zm4.625-4.125c-.05-1.645 1.27-2.48 2.223-2.48.742 0 1.367.37 1.578.902Zm5.797-1.418c-.356-.95-1.434-2.707-3.64-2.707-2.192 0-4.013 1.727-4.013 4.254 0 2.387 1.805 4.254 4.223 4.254 1.95 0 3.074-1.192 3.543-1.887l-1.45-.965c-.484.707-1.144 1.176-2.093 1.176-.953 0-1.629-.434-2.062-1.289l5.687-2.352Zm-45.309-1.398v1.8h4.32c-.128 1.016-.468 1.758-.984 2.274-.629.629-1.61 1.32-3.336 1.32-2.656 0-4.734-2.14-4.734-4.8 0-2.66 2.078-4.801 4.734-4.801a4.58 4.58 0 0 1 3.254 1.289l1.274-1.274c-1.079-1.031-2.512-1.82-4.528-1.82-3.64 0-6.699 2.965-6.699 6.605 0 3.641 3.059 6.606 6.7 6.606 1.968 0 3.448-.645 4.609-1.852 1.191-1.191 1.562-2.867 1.562-4.222a5.69 5.69 0 0 0-.098-1.125Zm11.078 5.523c-1.285 0-2.398-1.062-2.398-2.578 0-1.531 1.113-2.578 2.398-2.578 1.29 0 2.403 1.047 2.403 2.578 0 1.516-1.114 2.578-2.403 2.578m0-6.832c-2.351 0-4.265 1.79-4.265 4.254 0 2.45 1.914 4.254 4.265 4.254 2.352 0 4.274-1.805 4.274-4.254 0-2.465-1.922-4.254-4.274-4.254m9.317 6.832c-1.29 0-2.403-1.062-2.403-2.578 0-1.531 1.114-2.578 2.403-2.578s2.398 1.047 2.398 2.578c0 1.516-1.11 2.578-2.398 2.578m0-6.832c-2.352 0-4.27 1.79-4.27 4.254 0 2.45 1.918 4.254 4.27 4.254 2.351 0 4.27-1.805 4.27-4.254 0-2.465-1.919-4.254-4.27-4.254"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ea4335",
      fillOpacity: 1
    },
    d: "m20.719 19.422-10.649 11.3c0 .005 0 .008.004.008a2.869 2.869 0 0 0 2.774 2.13 2.85 2.85 0 0 0 1.46-.395l.036-.02 11.984-6.914"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fbbc04",
      fillOpacity: 1
    },
    d: "m31.488 17.5-.011-.008-5.172-3-5.828 5.188 5.847 5.847 5.149-2.968a2.882 2.882 0 0 0 1.511-2.536c0-1.09-.601-2.035-1.496-2.523"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4285f4",
      fillOpacity: 1
    },
    d: "M10.07 9.277a2.877 2.877 0 0 0-.097.739v19.968c0 .258.035.504.097.739l11.012-11.008"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#34a853",
      fillOpacity: 1
    },
    d: "m20.797 20 5.508-5.508-11.97-6.941a2.88 2.88 0 0 0-4.266 1.723l.001.003"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#download_googleplay_svg__a",
    x: 41.08,
    y: 13.133
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#download_googleplay_svg__b",
    x: 46.395,
    y: 13.133
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#download_googleplay_svg__c",
    x: 53.79,
    y: 13.133
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#download_googleplay_svg__d",
    x: 59.462,
    y: 13.133,
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#download_googleplay_svg__e",
    x: 62.03,
    y: 13.133
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#download_googleplay_svg__f",
    x: 67.163,
    y: 13.133
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#download_googleplay_svg__g",
    x: 72.767,
    y: 13.133,
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#download_googleplay_svg__h",
    x: 77.926,
    y: 13.133
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#download_googleplay_svg__g",
    x: 79.962,
    y: 13.133
  }))));
};
export default SvgDownloadGoogleplay;